import { cn } from "@/lib/utils";

// Map nation/country codes to flagcdn ISO codes
const FLAG_CODES: Record<string, string> = {
  // Nation code prefixes (from league codes like ENG_PL)
  'ENG': 'gb-eng',
  'SCO': 'gb-sct',
  'ESP': 'es',
  'GER': 'de',
  'ITA': 'it',
  'FRA': 'fr',
  'NED': 'nl',
  'POR': 'pt',
  'BEL': 'be',
  'TUR': 'tr',
  'AUT': 'at',
  'SUI': 'ch',
  'NOR': 'no',
  'SWE': 'se',
  'DEN': 'dk',
  'POL': 'pl',
  'CRO': 'hr',
  'USA': 'us',
  'BRA': 'br',
  'MEX': 'mx',
  'ARG': 'ar',
  'GRE': 'gr',
  'RUS': 'ru',
  'UKR': 'ua',
  'CZE': 'cz',
  
  // Country names (from club.country or league.country)
  'England': 'gb-eng',
  'Scotland': 'gb-sct',
  'Spain': 'es',
  'Germany': 'de',
  'Italy': 'it',
  'France': 'fr',
  'Netherlands': 'nl',
  'Portugal': 'pt',
  'Belgium': 'be',
  'Turkey': 'tr',
  'Austria': 'at',
  'Switzerland': 'ch',
  'Norway': 'no',
  'Sweden': 'se',
  'Denmark': 'dk',
  'Poland': 'pl',
  'Croatia': 'hr',
  'Russia': 'ru',
  'Ukraine': 'ua',
  'Czech Republic': 'cz',
  'Greece': 'gr',
  'United States': 'us',
  'Brazil': 'br',
  'Mexico': 'mx',
  'Argentina': 'ar',
};

interface CountryFlagProps {
  /** Country code (e.g., 'ENG', 'ESP') or country name (e.g., 'England', 'Spain') */
  code: string;
  /** Size of the flag */
  size?: 'sm' | 'md' | 'lg';
  /** Additional CSS classes */
  className?: string;
}

const CountryFlag = ({ code, size = 'md', className }: CountryFlagProps) => {
  const isoCode = FLAG_CODES[code] || code.toLowerCase();
  const flagUrl = `https://flagcdn.com/${isoCode}.svg`;
  
  const sizeClasses = {
    sm: 'w-4 h-3',
    md: 'w-6 h-4',
    lg: 'w-8 h-6',
  };
  
  return (
    <img 
      src={flagUrl}
      alt={`${code} flag`}
      className={cn(
        sizeClasses[size], 
        'inline-block object-cover rounded-sm',
        className
      )}
      loading="lazy"
      onError={(e) => {
        // Fallback to a generic flag on error
        e.currentTarget.src = 'https://flagcdn.com/xx.svg';
      }}
    />
  );
};

export { CountryFlag };
export default CountryFlag;
